import { ID } from '@datorama/akita';
import { RelationConfig } from '../../models/relation-config.model';
import { Address } from '../../models/address.model';

export interface Home {
  id: ID;
  person_id: number;
  price: string;
  woz: string;
  square_meter: number;
  cubic_meter: number;
  market_value: number;
  home_type_configuration_id: number;
  home_type: RelationConfig;
  construction_year: number;
  construction_type_configuration_id: RelationConfig;
  address: Address;
  country_configuration_id: number;
}

export function createHome(params: Partial<Home>) {
  return {
    country_configuration_id: 158
  } as Home;
}
